import axios from "axios";
import {db_url} from "../url";

export default function DB_ReportSale  (token)  {

    const getReportSale = (data) => {
        return axios.post(db_url + `/reports/sales`, data,{
        // return axios.post('http://localhost:3001/api_web/v1' + `/reports/sales`, data,{
            headers: {
                Authorization: token
            }
        })
    }

    return {
        getReportSale,
    }
}